import { Passenger, PnrInfo } from "src/app/core/models/itinerary.model";
import { AncillariesValidation, SpecialRequestItem } from "src/app/core/models/special-requests.model";
import { MiscUtil } from "./misc.util";

export class PnrUtil {
  static addSpecialRequestTempId(pnr: PnrInfo): PnrInfo {
    return { ...pnr, passengers: this.updatePassengers(pnr.passengers) };
  }

  static addAncillaryValidation(pnr: PnrInfo, ancillaries: AncillariesValidation[]): PnrInfo {
    return { ...pnr, passengers: this.updateValidationInPassengers(pnr.passengers, ancillaries) };
  }

  private static updatePassengers(passengers: Passenger[]): Passenger[] {
    return passengers.map((passenger) => ({ ...passenger, specialRequests: this.updateSpecialRequests(passenger.specialRequests) }));
  }

  private static updateSpecialRequests(specialRequests: SpecialRequestItem[]): SpecialRequestItem[] {
    return specialRequests.map((specialRequest) => ({ ...specialRequest, tempId: MiscUtil.uuid() }));
  }

  static updateValidationInPassengers(passengers: Passenger[], ancillaries: AncillariesValidation[]): Passenger[] {
    return passengers.map((passenger) => ({ ...passenger, specialRequests: this.updateValidationInSpecialRequests(passenger.specialRequests, ancillaries) }));
  }

  private static updateValidationInSpecialRequests(specialRequests: SpecialRequestItem[], ancillaries: AncillariesValidation[]): SpecialRequestItem[] {
    return specialRequests.map((specialRequest) => {
      const ancillaryToUpdate = ancillaries.find((ancillary) => ancillary.tempId === specialRequest.tempId);

      if (ancillaryToUpdate) {
        return {
          ...specialRequest,
          validation: {
            canBeApplied: ancillaryToUpdate.canBeApplied,
            currency: ancillaryToUpdate.currency,
            diffAmount: ancillaryToUpdate.diffAmount,
          },
        }
      }

      return specialRequest;
    });
  }
}
